import type { ColumnDef } from '@tanstack/react-table';

import type { GetQuizzesQuery } from 'data/__generated__';
import { textColumn, dateColumn } from 'components/DataTable';

export type QuizRow = GetQuizzesQuery['quizzes']['quizzes'][number];

export const quizzesColumns: ColumnDef<QuizRow, unknown>[] = [
    dateColumn<QuizRow, Record<string, unknown>>({
        accessorKey: 'createdAt',
        header: 'Date de création',
        filterKey: 'createdAt',
        defaultVisible: true,
    }),
    textColumn<QuizRow, Record<string, unknown>>({
        accessorKey: 'title',
        header: 'Question',
        filterKey: 'title',
        defaultVisible: true,
    }),
];
